import api from "@/services/api";

class ChangePassword {
  execute = async (password: string) => {
    const response = await api().put(`/change-password`, { password });
    return response.data;
  };
}

export { ChangePassword };
